module.exports = __webpack_public_path__ + "img/store-setup-orange.f557e1bb.svg";